import Phaser from 'phaser';
import { Meld, isBurraco, isCleanBurraco } from '../game/Meld';
import { CardSprite } from './CardSprite';
import { CARD_WIDTH, CARD_HEIGHT } from '../utils/Constants';

export class MeldDisplay {
  private scene: Phaser.Scene;
  private x: number;
  private y: number;
  private sprites: CardSprite[] = [];
  private labels: Phaser.GameObjects.Text[] = [];
  private onMeldClick?: (meldId: string) => void;
  private currentMelds: Meld[] = [];
  private columnWidth = CARD_WIDTH + 10;
  private cardOverlap = 20;

  constructor(scene: Phaser.Scene, x: number, y: number) {
    this.scene = scene;
    this.x = x;
    this.y = y;
  }

  setOnMeldClick(callback: (meldId: string) => void): void {
    this.onMeldClick = callback;
  }

  updateMelds(melds: Meld[]): void {
    // Clear existing
    for (const s of this.sprites) s.destroy();
    for (const l of this.labels) l.destroy();
    this.sprites = [];
    this.labels = [];
    this.currentMelds = melds;

    for (let m = 0; m < melds.length; m++) {
      const meld = melds[m];
      const colX = this.x + m * this.columnWidth;

      // Burraco indicator
      if (isBurraco(meld)) {
        const isClean = isCleanBurraco(meld);
        const label = this.scene.add.text(colX, this.y - 14, isClean ? 'PULITA' : 'SPORCA', {
          fontSize: '10px',
          color: isClean ? '#2ecc71' : '#e67e22',
          fontFamily: 'Georgia, serif',
          fontStyle: 'bold',
        }).setOrigin(0.5, 1).setDepth(50);
        this.labels.push(label);
      }

      for (let c = 0; c < meld.cards.length; c++) {
        const cardY = this.y + c * this.cardOverlap;
        const sprite = new CardSprite(this.scene, colX, cardY, meld.cards[c], true);
        sprite.setDepth(5 + c);

        if (this.onMeldClick) {
          const meldId = meld.id;
          sprite.on('pointerdown', () => {
            if (this.onMeldClick) this.onMeldClick(meldId);
          });
        }

        this.sprites.push(sprite);
      }
    }
  }

  /** Returns the meld ID if the given position is over a meld column, or null */
  getMeldAtPosition(worldX: number, worldY: number): string | null {
    for (let m = 0; m < this.currentMelds.length; m++) {
      const meld = this.currentMelds[m];
      const colX = this.x + m * this.columnWidth;
      const meldHeight = CARD_HEIGHT + (meld.cards.length - 1) * this.cardOverlap;

      const left = colX - CARD_WIDTH / 2;
      const right = colX + CARD_WIDTH / 2;
      const top = this.y - CARD_HEIGHT / 2;
      const bottom = top + meldHeight;

      if (worldX >= left && worldX <= right && worldY >= top && worldY <= bottom) {
        return meld.id;
      }
    }
    return null;
  }

  highlightMeld(meldId: string): void {
    // Visual feedback — not needed since we just need to know which meld
  }

  destroy(): void {
    for (const s of this.sprites) s.destroy();
    for (const l of this.labels) l.destroy();
    this.sprites = [];
    this.labels = [];
  }
}
